export default __webpack_public_path__ + "static/6.5 - 2-dc2434c838efe02a3bb465ddbb015174.png";